import { render } from "./BuybackSkuMpConfig.vue?vue&type=template&id=1829f10d&scoped=true&ts=true&lang=pug"
import script from "./BuybackSkuMpConfig.vue?vue&type=script&lang=ts"
export * from "./BuybackSkuMpConfig.vue?vue&type=script&lang=ts"

import "./BuybackSkuMpConfig.vue?vue&type=style&index=0&id=1829f10d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1829f10d"]])

export default __exports__